import { render } from "./edit_mold.vue?vue&type=template&id=e9b99fe8&scoped=true"
import script from "./edit_mold.vue?vue&type=script&lang=js"
export * from "./edit_mold.vue?vue&type=script&lang=js"

import "./edit_mold.vue?vue&type=style&index=0&id=e9b99fe8&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b99fe8"]])

export default __exports__